import React from "react";
import { FONT } from "../../kota/ui";

// Juragan sawah: pemilik lahan berblangkon & batik yang berdiri di pinggir sawah sambil berkomentar sarkas.
// 3 ekspresi (ilustrasi AI, /kerja/juragan_{pesan|kecewa|puas}.webp) ditumpuk & dimuat sejak awal → ganti ekspresi instan.
const GAMBAR = { pesan: "/kerja/juragan_pesan.webp", kecewa: "/kerja/juragan_kecewa.webp", puas: "/kerja/juragan_puas.webp" };
if (typeof Image !== "undefined") Object.values(GAMBAR).forEach(src => { const im = new Image(); im.src = src; });

export function Juragan({ nama, nada = "pesan", ucapan }) {
  const warna = nada === "kecewa" ? "#dc2626" : nada === "puas" ? "#2e9e5b" : "rgba(0,0,0,.14)";
  const aktif = GAMBAR[nada] ? nada : "pesan";
  return (
    <div data-testid="juragan" data-nada={nada} style={{ position: "absolute", inset: 0, fontFamily: FONT, pointerEvents: "none" }}>
      {Object.entries(GAMBAR).map(([k, src]) => (
        <img key={k} src={src} alt="" draggable={false} data-testid={`juragan-gambar-${k}`}
          style={{ position: "absolute", left: 6, bottom: 0, height: "100%", width: "auto", opacity: aktif === k ? 1 : 0, transition: "opacity .12s", filter: "drop-shadow(0 6px 6px rgba(20,20,20,.22))" }} />
      ))}
      {ucapan && (
        <div data-testid="ucapan" key={ucapan} style={{ position: "absolute", left: "30%", right: 12, top: 4, padding: "7px 11px 8px", borderRadius: 16, borderBottomLeftRadius: 6, background: "#fff", border: `2px solid ${warna}`, boxShadow: "0 8px 24px rgba(20,20,20,.14)", animation: "jw-datang .25s ease-out" }}>
          <span style={{ display: "block", fontSize: 10.5, fontWeight: 700, color: "#6b6b6b", marginBottom: 2 }}>{nama} · Juragan</span>
          <span style={{ fontSize: 13, fontWeight: 700, lineHeight: 1.3, color: "#141414" }}>{ucapan}</span>
          <span style={{ position: "absolute", left: -11, top: 18, width: 0, height: 0, borderTop: "7px solid transparent", borderBottom: "7px solid transparent", borderRight: "12px solid #fff", filter: `drop-shadow(-2px 0 0 ${warna})` }} />
        </div>
      )}
      <style>{`@keyframes jw-datang{0%{opacity:0;transform:translateY(8px)}100%{opacity:1;transform:translateY(0)}}`}</style>
    </div>
  );
}
